import { useMutation, useQueryClient } from '@tanstack/react-query'

import { putRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { MutationConfig } from 'src/lib/react-query'
import type { Invite, InviteUpdate } from 'src/shared/schemas/invites/invite'

interface UpdateInviteParams {
  inviteId: number
  data: InviteUpdate
}

export const updateInvite = async ({ inviteId, data }: UpdateInviteParams): Promise<Invite> => {
  const response = await putRequest<Invite>(`/users/invites?invite_id=${inviteId}`, data)
  if (!response) throw new Error('Failed to update invite')
  return response
}

export const useUpdateInvite = (config?: MutationConfig<typeof updateInvite>) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateInvite,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queries.invites._def })
    },
    ...config,
  })
}
